export const useAuth = () => {
    // Local storage private key
    function setPrivateKey(privateKey) {
        localStorage.setItem('tentprivateKey', privateKey);
    }

    function getPrivateKey() {
        return localStorage.getItem('tentprivateKey');
    }

    // Local storage logins
    function setLogin(param) {
        localStorage.setItem('tentloginStorage', JSON.stringify(param));
    }

    function getLogin() {
        return localStorage.getItem('tentloginStorage');
    }

    function Logout() {
        localStorage.removeItem('tentloginStorage');
        localStorage.removeItem('tentsidebarState');
        window.location.assign('/login');
    }

    return {
        setLogin,
        getLogin,
        Logout,
        setPrivateKey,
        getPrivateKey,
    };
};
